import { useState } from "react";
import { Fragment } from "react/jsx-runtime";

import { PartDto } from "#modules/parts/infra/fetchPart.api";
import { Icon } from "#shared/icons/Icon";
import { IconName } from "#shared/icons/Icon";
import { Box } from "#shared/view/components/Box";
import { Flex } from "#shared/view/components/Flex";
import { Thumbnail } from "#shared/view/components/Thumbnails/Thumbnail";
import { TooltipContent } from "#shared/view/components/Thumbnails/TooltipContent";
import { Tooltip } from "#shared/view/designSystem/Tooltip";

export const ErrorThumbnail = ({
  size = { width: 55, height: 55 },
  icon,
  errorMessage,
  part,
}: {
  size?: { width: number | string; height: number | string };
  icon?: IconName;
  errorMessage: string;
  part: PartDto;
}) => {
  const [shouldDisplayTooltip, setShouldDisplayTooltip] = useState(false);

  return (
    <Fragment>
      <Tooltip
        style={{ pointerEvents: "auto" }}
        events={{ hover: false, focus: true, touch: true }}
        withArrow
        opened={shouldDisplayTooltip}
        transitionProps={{ transition: "pop", duration: 200 }}
        label={
          <TooltipContent
            partId={part.id}
            errorMessage={errorMessage}
            setShouldDisplayTooltip={setShouldDisplayTooltip}
          />
        }
      >
        <Box
          data-testid="error-thumbnail"
          pos="relative"
          h={size.height}
          w={size.width}
          onClick={() => setShouldDisplayTooltip(true)}
          style={{ cursor: "pointer" }}
        >
          <Flex
            align={"center"}
            justify={"center"}
            h={"100%"}
            w="100%"
            px={"md"}
            pos="absolute"
            top={0}
            left={0}
          >
            {icon && <Icon name={icon} size={20} color="red" />}
          </Flex>

          <Thumbnail part={part} size={size} />
        </Box>
      </Tooltip>
    </Fragment>
  );
};
